var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useRef, useState, } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
// icons
import CustomIllustration from "@frameworks/shared-library/assets/images/features/Markets/Pms/custom-Illustration.svg";
// components
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import RecentSearchesPopup from "./RecentSearchesPopup";
import ClientSearch from "../../components/ClientSearch";
// helpers
import { debounce } from "@frameworks/salesjourney/utils/genericMethods";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { accountDetails } from "@mainDi/salesDi";
// types
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import { capitalizeWords } from "../../utils";
import actions from "@mainDi/features/AIF-PMS/actions";
import * as URLConfig from "@frameworks/salesjourney/config/domain";
var CommonClientSearch = function (_a) {
    var openSB = _a.openSB, onSelectClient = _a.onSelectClient, subCategoryId = _a.subCategoryId;
    //
    var searchParams = new URLSearchParams(location.search);
    var clientDetails = useSelector(function (state) { return state.markets.AifPms; }).clientDetails;
    var searchRef = useRef(null);
    var searchInputRef = useRef(null);
    var _b = __read(useState(false), 2), searchPopup = _b[0], setSearchPopup = _b[1];
    var _c = __read(useState(""), 2), searchText = _c[0], setSearchText = _c[1];
    var _d = __read(useState(false), 2), isSearchFocused = _d[0], setIsSearchFocused = _d[1];
    var _e = __read(useState(false), 2), loader = _e[0], setLoader = _e[1];
    var _f = __read(useState([]), 2), ClientSearchData = _f[0], setClientSearchData = _f[1];
    var _g = __read(useState([]), 2), recentSearches = _g[0], setRecentSearches = _g[1];
    var callBackFunctionClientSearch = function (data) {
        setSearchPopup(true);
        aifPmsDi.global.recentClientSearchSave({
            categoryCode: subCategoryId,
            uccCode: data.ucccode,
            searchText: searchText,
        });
        if (onSelectClient) {
            onSelectClient(data);
        }
        aifPmsDi.aifPms.updateClientDetails(data);
    };
    var handleOnchangeSearch = function (e) {
        var inputValue = e.target.value;
        setSearchText(inputValue);
        if (inputValue.length < 3) {
            setClientSearchData([]);
            return;
        }
        setLoader(true);
        setSearchPopup(true);
        debounce(function () { return getClientSearchData(inputValue); });
        setLoader(false);
    };
    useEffect(function () {
        if (isSearchFocused) {
            setIsSearchFocused(false);
        }
    }, [openSB]);
    useEffect(function () {
        var uccCode = searchParams.get("ucc");
        setSearchText(uccCode || "");
    }, []);
    var handleSelect = function (item) {
        setSearchPopup(true);
        setIsSearchFocused(true);
        setSearchText(item.search_txt);
        getClientSearchData(item.search_txt);
    };
    useEffect(function () {
        aifPmsDi.global
            .recentClientSearchGet({
            categoryCode: subCategoryId,
        })
            .then(function (data) {
            setRecentSearches(data === null || data === void 0 ? void 0 : data.data);
        })
            .catch(function (error) { });
    }, []);
    var getClientSearchData = function (searchText) { return __awaiter(void 0, void 0, void 0, function () {
        var loginCode, userType, loginType, getClientForSelectedRMPayload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoader(true);
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 1:
                    loginCode = _a.sent();
                    userType = "";
                    loginType = localStorage.getItem(ELocalStorageKeys.LoginType);
                    switch (loginType) {
                        case ILoginTypeEnum.RM:
                            userType = "Employee";
                            break;
                        case ILoginTypeEnum.FRM:
                            userType = "Employee";
                            break;
                        case ILoginTypeEnum.PARTNER:
                            userType = "Partner";
                            break;
                        default:
                            break;
                    }
                    getClientForSelectedRMPayload = {
                        userType: userType.toLowerCase(),
                        userId: loginCode,
                        searchText: searchText,
                        page: "1",
                        pageSize: "100",
                    };
                    aifPmsDi.global
                        .uccClientSearch(getClientForSelectedRMPayload)
                        .then(function (response) {
                        var _a;
                        var filteredClients = (_a = response.data.ranked_employees) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                            return {
                                clientName: capitalizeWords(item.acname),
                                userName: item.user_name,
                                accountCode: item.priority_ac_code,
                                pan: item.pan,
                                mobileNo: item.mobileno,
                                email: item.email,
                                uniqueCode: item.ucccode,
                                isVerified: true,
                                dpFlag: item.dp_flag,
                                accType: item.actype,
                                ucccode: item.ucccode,
                                ispansearch: item.ispansearch,
                                clienttier: item.clienttier,
                                client_owner_name: item.client_owner_name,
                                client_owner: item.client_owner,
                            };
                        });
                        setClientSearchData(filteredClients);
                        setLoader(false);
                    })
                        .catch(function (error) {
                        setLoader(false);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var ClientInfo = useMemo(function () {
        return (React.createElement(ClientSearch, { clientSearchList: ClientSearchData, searchText: searchText, loader: loader, setCallbackFunction: function (data) {
                callBackFunctionClientSearch(data);
                var cActions = actions();
                cActions.global.toggleLeadSelection(false);
            }, productNumber: subCategoryId }));
    }, [ClientSearchData, loader, searchText, callBackFunctionClientSearch]);
    useEffect(function () {
        function handleClickOutside(event) {
            if (searchRef.current &&
                !searchRef.current.contains(event.target)) {
                setIsSearchFocused(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchRef]);
    var onClearSearch = function () {
        setSearchText("");
        setSearchPopup(false);
        searchInputRef.current.focus();
    };
    return (React.createElement("div", { className: "bg-white px-3 py-4-custom rounded box-shadow-light" },
        React.createElement("div", { className: "d-flex justify-content-between mb-2" },
            React.createElement("p", { className: "DMSanN_14_400 txt_blackOne1" }, "Client Name"),
            React.createElement(EdButton, { onClick: function () {
                    var path = "".concat(URLConfig.config.applicationRoot, "dashboard/leadpage");
                    window.open(path, "_BLANK");
                }, btnTyp: "link", value: React.createElement("u", null, "Add new client"), className: "DMSanM_14_500 p-0 fit-content fw-500" })),
        React.createElement(Form, { className: "common-search ".concat(isSearchFocused && "active-input", " d-flex align-items-center position-relative"), ref: searchRef },
            React.createElement("div", { className: "search-input-icons-container d-flex align-items-center gap-2 w-100" },
                React.createElement("div", { className: "search_icon_ap" },
                    React.createElement("i", { className: "edel-icon-search" })),
                React.createElement("input", { className: "DMSanN_14_400 txt_blue-tint d-flex bg-transparent w-100 ".concat(isSearchFocused && ""), type: "search", value: searchText, placeholder: "Search by Client's name/ PAN/ UCC", "aria-label": "Search", onChange: handleOnchangeSearch, onFocus: function () { return setIsSearchFocused(true); }, ref: searchInputRef }),
                isSearchFocused && searchText && (React.createElement("span", { className: "edel-icon-close cross-icon hand_cursor", onClick: onClearSearch }))),
            isSearchFocused ? (React.createElement("div", { className: "px-0 py-2 position-absolute bg_white ".concat(clientDetails == null
                    ? "clientsearch-popup-aif-pms h-auto"
                    : "clientsearch-popup-aif-pms", " search-result-shadow header overflow-x-hidden  d-flex flex-column align-items-start") },
                isSearchFocused && !searchText && (React.createElement(RecentSearchesPopup, { searches: recentSearches, onSelect: handleSelect })),
                (searchText === null || searchText === void 0 ? void 0 : searchText.length) > 2 && searchPopup && (React.createElement(React.Fragment, null,
                    (ClientSearchData === null || ClientSearchData === void 0 ? void 0 : ClientSearchData.length) > 0 && (React.createElement("p", { className: "DMSans_13_500 not-found" }, "".concat(ClientSearchData.length, " ").concat((ClientSearchData === null || ClientSearchData === void 0 ? void 0 : ClientSearchData.length) > 1 ? "results" : "result", " found"))),
                    ClientInfo)))) : null),
        React.createElement("img", { src: CustomIllustration, className: "position-absolute bottom-0 end-0" })));
};
export default CommonClientSearch;
